export default {
	methods: {
		parseZombies(clean, showOK) {
			const { modify, warning, zombie } = clean;
			// if (this.getUser && this.getUser.roletype === "1" && warning.length === 0) {
			// 	console.log('found special user');
			// 	return;
			// }
			if (modify === 0 && warning.length === 0 && zombie === 0 && showOK) {
				this.$message(this.$t('statusGrid.zombies.noTasksNoProblems'));
			} else if (modify > 0 && warning.length === 0 && zombie === 0) {
				this.$alert(
					`${this.$t('statusGrid.zombies.emergency')} 
					<br/>
					${this.$t('statusGrid.zombies.tasksCleared', { number: modify })}
					<br/>
					${this.$t('statusGrid.zombies.tasksInfo')}
				`, '', {
					confirmButtonText: 'OK',
					dangerouslyUseHTMLString: true
				});
			} else if (zombie > 0 && warning.length === 0) {
				this.$alert(
					`${this.$t('statusGrid.zombies.emergency')} 
					<br/>
					${this.$t('statusGrid.zombies.tasksAndZombies', {
						number: modify,
						zombie
					})}
					<br/>
					${this.$t('statusGrid.zombies.tasksInfo')}
					<br/>
					${this.$t('statusGrid.zombies.goToAdmin')}
					`,
					'',
					{
						confirmButtonText: 'OK',
						dangerouslyUseHTMLString: true
					}
				);
			} else if (warning.length > 0) {
				const h = this.$createElement;
				let messageArray = [];
				let showInfo = false;
				if (this.getUser && this.getUser.roleid <= 1) {
					messageArray.push(h('div', null, this.$t('statusGrid.zombies.warningsServers')));
					for (const ob of warning) {
						messageArray.push(h('div', null, ` • ${ob.sn} -- ${ob.er}`));
					}
				}
				else messageArray.push(h('div', null, this.$t('statusGrid.zombies.errorsOnServers')));
				messageArray.push(h('br'));
				if (zombie > 0) {
					messageArray.push(h('div', null, this.$t('statusGrid.zombies.zombies', { zombie })));
					showInfo = true;
				}
				messageArray.push(h('br'));
				if (modify > 0) {
					messageArray.push(
						h('div', null, this.$t('statusGrid.zombies.tasksCleared', { number: modify }))
					);
					showInfo = true;
				}
				else messageArray.push(h('div', null, this.$t('statusGrid.zombies.noTasksCleared')));
				if (showInfo) {
					messageArray.push(h('br'));
					messageArray.push(h('div', null, this.$t('statusGrid.zombies.tasksInfo')));
					messageArray.push(h('br'));
					messageArray.push(h('div', null, this.$t('statusGrid.zombies.goToAdmin')));

				}
				this.$msgbox({
					title: '',
					message: h('p', null, messageArray),
					showCancelButton: false,
					confirmButtonText: 'OK'
				});
			}
		}
	}
};
